import React, { useContext } from "react";
import clsx from "clsx";
import WebProfileContext from "@WebProfileContext";
import ReactSVGIcon from "@micado-digital/react-svg-icon/ReactSVGIcon";

import styles from "./Phone.styles";

const Phone = ({ lang }) => {
	const [profileData] = useContext(WebProfileContext);
	const { phone } = profileData;
	const css = styles();

	return (
		<a
			aria-label={
				lang === "de"
					? `${phone?.replace(/ /g, "")} anrufen`
					: `Call ${phone?.replace(/ /g, "")}`
			}
			className={clsx(css.phone, "mco-view-component-header__phone")}
			href={"tel:" + phone?.replace(/ /g, "")}
		>
			<ReactSVGIcon src="/img/icons/phone.svg" size={24} />
		</a>
	);
};

export default Phone;
